/**
 * This mixin is meant to be used by modal and popover components.
 * It keeps the tabbing within the modal/popover until the user exits
 * the popover/modal.
 * The top element in the component should have a tab event that calls
 * handleTab: @keydown.tab="handleTab"
 * It is the responsibility of the component inside the modal to set the first element to focus on.
 */
import domUtils from 'util/dom-utils'

export default {
  methods: {
    getFirstTabbableElement(tabbableElements) {
      let firstElement = tabbableElements[0]
      if (firstElement.type === 'radio') {
        firstElement = this.getTabToRadioBtn(firstElement.name, true)
      }
      return firstElement
    },
    getLastTabbableElement(tabbableElements) {
      let lastElement = tabbableElements[tabbableElements.length - 1]
      if (lastElement.type === 'radio') {
        lastElement = this.getTabToRadioBtn(lastElement.name, false)
      }
      return lastElement
    },
    getTabToRadioBtn(radioGroupName, forward) {
      const radioBtns = this.$el.querySelectorAll(`[name=${radioGroupName}]`)
      // if one is checked, that trumps all
      for (let i = 0; i < radioBtns.length; i++) {
        if (radioBtns[i].checked) {
          return radioBtns[i]
        }
      }
      // if tabbing forward, it's the first button we select, if backwards its the last
      return forward ? radioBtns[0] : radioBtns[radioBtns.length - 1]
    },
    isFirstTabbableElement(elem, tabbableElements) {
      return elem === tabbableElements[0] || (elem.type === 'radio' &&
        tabbableElements[0].type === 'radio' && elem.name === tabbableElements[0].name)
    },
    isLastTabbableElement(elem, tabbableElements) {
      const trueLast = tabbableElements[tabbableElements.length - 1]
      return elem === trueLast || (elem.type === 'radio' && trueLast.type === 'radio' &&
        elem.name === trueLast.name)
    },
    handleTab(e) {
      const tabbableElements = domUtils.getTabbableElements(this.$el)
      if (e.shiftKey && this.isFirstTabbableElement(e.target, tabbableElements)) {
        // is on the first element, since this is shift+tab, need to now focus on last element
        e.preventDefault()
        this.getLastTabbableElement(tabbableElements).focus()
      } else if (!e.shiftKey && this.isLastTabbableElement(e.target, tabbableElements)) {
        e.preventDefault()
        this.getFirstTabbableElement(tabbableElements).focus()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/mixins/modal-tab-control-mixin.ts